import './ResetPasswordPage.scss';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import update from 'immutability-helper';

import { updateTitle } from 'containers/App/store/actions';
import { clearError, clearResetPasswordForm, postPasswordReset, updateAuth, updateCredentials, updateResetPasswordForm } from '../store/actions';

import Content from 'components/Content';
import ResetPasswordForm from './ResetPasswordForm';

class ResetPasswordPage extends React.Component {
    componentWillMount() {
        this.props.updateTitle('Reset Password');
        document.body.classList.add('auth-page');
    }

    componentWillUnmount() {
        document.body.classList.remove('auth-page');

        this.props.clearError();
    }

    _handleChange(event) {
        let fieldName = event.target.getAttribute('name');
        if(fieldName === 'userName') {
            let newAuthObj = update(this.props.auth.credentials, {});
            newAuthObj[fieldName] = event.target.value;
            this.props.updateCredentials(newAuthObj);
        } else {
            let newResetPasswordFormObj = update(this.props.auth.resetPasswordForm, {});
            newResetPasswordFormObj[fieldName] = event.target.value;
            this.props.updateResetPasswordForm(newResetPasswordFormObj);
        }
    }

    _handleSubmit(isValid) {
        if(isValid === true) {
            this.props.postPasswordReset(() => {
                let newAuthObj = update(this.props.auth, {
                    error: {$set: {friendlyMessage: 'Success!'}}
                });
                this.props.updateAuth(newAuthObj);
                setTimeout(() => {
                    this.props.changeLocation('/login');
                    this.props.clearResetPasswordForm();
                }, 500);
            });
        }
    }

    render() {
        let { auth } = this.props;
        return (
            <Content className="">
                <ResetPasswordForm handleChange={this._handleChange.bind(this)}
                                   onValid={this._handleSubmit.bind(this, true)}
                                   onInvalid={this._handleSubmit.bind(this, false)}
                                   resetPasswordFormData={auth.resetPasswordForm}
                                   userName={auth.credentials.userName}
                                   authError={auth.error} />
            </Content>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (locationString) => dispatch(routerActions.push(locationString)),
        clearError: () => dispatch(clearError()),
        clearResetPasswordForm: () => dispatch(clearResetPasswordForm()),
        postPasswordReset: (callback) => dispatch(postPasswordReset(callback)),
        updateAuth: (authObj) => dispatch(updateAuth(authObj)),
        updateCredentials: (credentialsObj) => dispatch(updateCredentials(credentialsObj)),
        updateResetPasswordForm: (resetPasswordFormDataObj) => dispatch(updateResetPasswordForm(resetPasswordFormDataObj)),
        updateTitle: (string) => dispatch(updateTitle(string))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage);



// WEBPACK FOOTER //
// ./src/containers/AuthPages/ResetPasswordPage/index.js